import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Formik, Form, ErrorMessage, Field } from 'formik';
import {
  addQuery,
  changeInFieldInclude,
  createSelectOptionsForField,
  removeQuery,
  updateQuery,
  compressConditions,
  processQueryData,
  generateQueryString,
  createSelectOptionsForSortField,
  createSelectOptionsForReferenceField,
  processRlsFilterQueryData,
} from './query-util';
import { primaryQueries } from './query-constant';
import CustomSelect from '../../../home/collections/CustomSelect';
import QueryCondition from './QueryCondition';
import { drapcodeIcon } from '../../../../common/custom/icon-library';
import { Mixpanel } from '../../../../common/utils/mixpanelUtil';
import CustomInputWithIcon from '../../../../common/ui/CustomInputWithIcon';
import CustomRadio from '../../../../common/ui/CustomRadio';
import {
  collectionFilterSelectorText,
  collectionFilterSortByText,
  collectionFilterSortOrder,
} from '../../../../common/docs/content';
import {
  FilterSchema,
  FilterSchemaValidation,
  RowLevelSecurityFilterSchemaValidation,
} from '../../../../common/utils/collectionFilterSchema';
import { toast } from 'react-toastify';
import TooltipInfo from '../../../../common/docs/TooltipInfo';
import { pluginCode } from 'drapcode-constant';
import { getCookie } from '../../../../common/utils/api_utils';

export default class DerivedQueryForm extends Component {
  static propTypes = {
    actions: PropTypes.object.isRequired,
    commonActions: PropTypes.object.isRequired,
    projectId: PropTypes.string.isRequired,
    collection: PropTypes.object.isRequired,
    collections: PropTypes.object.isRequired,
  };

  state = {
    primaryQuery: null,
    selectedIncludeField: [{ label: 'All', value: 'ALL' }],
    orderByOptions: [
      { label: 'Ascending', value: 'asc' },
      { label: 'Descending', value: 'desc' },
    ],
    selectOrderBy: { label: 'Ascending', value: 'asc' },
    selectedExcludeField: null,
    aggregateFunctionField: null,
    selectSortField: { label: 'Created At', value: 'createdAt' },
    conditions: [],
    enableRlsChecked: false,
    rlsFilter: null,
    addDerivedFieldMappingChecked: false,
  };

  addQueryInCondition = () => {
    const conditions = addQuery(this.state.conditions);
    this.setState({ conditions });
  };

  removeQueryFromCondition = (id) => {
    const conditions = removeQuery(this.state.conditions, id);
    this.setState({ conditions });
    toast.success('Condition Deleted Successfully !', {});
  };

  saveQuery = (id, conditionObj) => {
    const conditions = updateQuery(this.state.conditions, id, conditionObj);
    this.setState({ conditions });
    toast.success('Condition Saved Successfully !', {});
  };

  handleChange = (name, value) => {
    const updatedValue = changeInFieldInclude(name, value);
    this.setState({ [name]: updatedValue });
  };

  handleSubmit = (values) => {
    const { projectId, collection, version, rls, actions, commonActions } = this.props;
    const { addQueryToCollection, createRowLevelSecurityFilterInCollection } = actions;
    const conditionData = compressConditions(this.state.conditions);
    if (rls) {
      const queryData = processRlsFilterQueryData(values, conditionData);
      createRowLevelSecurityFilterInCollection({
        projectId,
        version,
        collectionUuid: collection.uuid,
        data: queryData,
      });
      commonActions.trackCollectionChange({
        uuid: collection.uuid,
      });
    } else {
      const queryData = processQueryData(values, conditionData);
      addQueryToCollection({
        projectId,
        version,
        collectionUuid: collection.uuid,
        data: queryData,
      });
      commonActions.trackCollectionChange({
        uuid: collection.uuid,
      });
    }

    this.setState({ conditions: conditionData.conditions });
  };

  clearForm = () => {
    this.setState({
      conditions: [],
      primaryQuery: '',
      selectedIncludeField: [{ label: 'All', value: 'ALL' }],
      selectedExcludeField: null,
      selectSortField: { label: 'Created At', value: 'createdAt' },
      selectOrderBy: { label: 'Ascending', value: 'asc' },
      aggregateFunctionField: null,
      enableRlsChecked: false,
      addDerivedFieldMappingChecked: false,
      rlsFilter: null,
    });
  };

  renderExcludeFieldSelect = (options, setFieldValue, setFieldTouched) => {
    const { selectedIncludeField } = this.state;
    if (selectedIncludeField) {
      const checkAllExist = selectedIncludeField[0];
      if (checkAllExist.value === 'ALL') {
        return (
          <CustomInputWithIcon title="Exclude" icon="select">
            <CustomSelect
              name="selectedExcludeField"
              isMulti={true}
              value={this.state.selectedExcludeField}
              options={options}
              onChange={setFieldValue}
              onBlur={setFieldTouched}
              onChangeValue={this.handleChange}
              placeholder="Exclude"
            />
            <ErrorMessage name="selectedExcludeField">
              {(msg) => <p className="text-error">{msg}</p>}
            </ErrorMessage>
          </CustomInputWithIcon>
        );
      }
    }
  };

  createConditionField = (setFieldValue, setFieldTouched) => {
    const { collection, collections, actions, projectId, version, rls } = this.props;
    const { conditions } = this.state;
    let collectionFields = createSelectOptionsForField(collection.fields);
    return conditions.map((condition) => (
      <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode" key={condition.id}>
        <div className="card">
          <div className="card-header card-header-text" data-background-color="drapcode-violet">
            <h6 className="card-title pb-0 mb-0 text-capitalise">Condition #{condition.id}</h6>
          </div>

          <div className="card-content">
            <div className="row mx-auto">
              <QueryCondition
                collections={collections}
                actions={actions}
                projectId={projectId}
                version={version}
                fieldOptions={collectionFields}
                fields={collection.fields}
                constants={collection.constants}
                setFieldValue={setFieldValue}
                setFieldTouched={setFieldTouched}
                condition={condition}
                removeQuery={this.removeQueryFromCondition}
                saveQuery={this.saveQuery}
                rls={rls}
              />
            </div>
          </div>
        </div>
      </div>
    ));
  };

  createSortFieldSelector = (setFieldValue, setFieldTouched) => {
    const { collection } = this.props;
    let collectionFields = createSelectOptionsForSortField(collection.fields);
    return (
      <CustomInputWithIcon icon="select" title="Sort By" required={true}>
        <CustomSelect
          name="selectSortField"
          isMulti={false}
          value={this.state.selectSortField}
          options={collectionFields}
          onChange={setFieldValue}
          onBlur={setFieldTouched}
          onChangeValue={this.handleChange}
          placeholder="Sort By"
        />
        <ErrorMessage name="selectSortField">
          {(msg) => <p className="text-error">{msg}</p>}
        </ErrorMessage>
        <TooltipInfo
          title={collectionFilterSortByText}
          headerText={`Select Sort By`}
          showHeader={true}
          showArrow={true}
        />
      </CustomInputWithIcon>
    );
  };

  createQuerySelector = (setFieldValue, setFieldTouched) => {
    let { primaryQuery } = this.state;
    if (!primaryQuery) {
      return '';
    }
    primaryQuery = primaryQuery.value;
    if (primaryQuery === 'FIND' || primaryQuery === 'FIND_ALL') {
      const { collection, collections } = this.props;
      const collectionFields = createSelectOptionsForField(collection.fields);
      const referenceFields = createSelectOptionsForReferenceField(
        collection.fields,
        collections.projectCollections,
      );
      const derivedFieldsOptions = collection.utilities.map((field) => {
        let fieldStr = JSON.stringify(field);
        fieldStr = fieldStr.replaceAll('"', '*#*#');
        return {
          value: `DF::${fieldStr}`,
          label: field.name,
        };
      });
      // Todo: Custom Derived Field can cause issue
      const includeCollectionFields = [
        { label: 'Fields', options: [{ value: 'ALL', label: 'All' }, ...collectionFields] },
        { label: 'Reference Fields', options: referenceFields },
        { label: 'Derived Fields', options: derivedFieldsOptions },
      ];
      return (
        <>
          <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12">
            <CustomInputWithIcon icon="select" title="Include" required={true}>
              <CustomSelect
                name="selectedIncludeField"
                isMulti={true}
                value={this.state.selectedIncludeField}
                options={includeCollectionFields}
                onChange={setFieldValue}
                onBlur={setFieldTouched}
                onChangeValue={this.handleChange}
                placeholder="Include"
              />
              <ErrorMessage name="selectedIncludeField">
                {(msg) => <p className="text-error">{msg}</p>}
              </ErrorMessage>
            </CustomInputWithIcon>
          </div>
          <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12">
            {this.renderExcludeFieldSelect(collectionFields, setFieldValue, setFieldTouched)}
          </div>
        </>
      );
    } else if (['AVG', 'SUM', 'MAX', 'MIN'].includes(primaryQuery)) {
      const { collection } = this.props;
      let collectionFields = createSelectOptionsForField(collection.fields);
      const includeCollectionFields = [...collectionFields];
      return (
        <>
          <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12">
            <CustomInputWithIcon icon="select" title="Include" required={true}>
              <CustomSelect
                name="aggregateFunctionField"
                isMulti={false}
                value={this.state.aggregateFunctionField}
                options={includeCollectionFields}
                onChange={setFieldValue}
                onBlur={setFieldTouched}
                onChangeValue={this.handleChange}
                placeholder="Aggregate Function Field"
              />
              <ErrorMessage name="aggregateFunctionField">
                {(msg) => <p className="text-error">{msg}</p>}
              </ErrorMessage>
            </CustomInputWithIcon>
          </div>
        </>
      );
    } else {
      return '';
    }
  };

  showQuery = () => {
    const { projectCollections } = this.props.collections;
    return (
      <>
        {typeof this.state !== 'undefined' && this.state.primaryQuery ? (
          <blockquote className="blockquote border-brand-green">
            <p className="mb-0">{generateQueryString(this.state, projectCollections)}</p>
          </blockquote>
        ) : (
          ''
        )}
      </>
    );
  };

  setBtnDisabled = () => {
    const { conditions } = this.state;
    let btnDisabled = false;
    if (conditions.length > 0) {
      conditions.forEach((condition) => {
        if (!condition.saved) {
          btnDisabled = true;
        }
      });
    }
    return btnDisabled;
  };

  handleEnableRlsChange = (event) => {
    this.setState({ enableRlsChecked: event.target.checked });
  };

  handleAddDerivedFieldMappingChange = (event) => {
    this.setState({ addDerivedFieldMappingChecked: event.target.checked });
  };

  selectRlsFilter = (setFieldValue, setFieldTouched) => {
    const { collection } = this.props;
    const { rlsFilter } = this.state;
    const { rowLevelSecurityFilter } = collection;
    const rlsOptions = rowLevelSecurityFilter.map((filter) => ({
      value: filter.uuid,
      label: filter.name,
    }));
    return (
      <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12">
        <CustomInputWithIcon icon="select" title="Row Level Security Filters" required={true}>
          <CustomSelect
            name="rlsFilter"
            isMulti={false}
            value={rlsFilter}
            options={rlsOptions}
            onChange={setFieldValue}
            onBlur={setFieldTouched}
            onChangeValue={this.handleChange}
            placeholder="Select Row Level Security Filter"
          />
          <ErrorMessage name="rlsFilter">
            {(msg) => <p className="text-error">{msg}</p>}
          </ErrorMessage>
        </CustomInputWithIcon>
      </div>
    );
  };

  selectDerivedFieldMapping = (setFieldValue, setFieldTouched) => {
    const { collection } = this.props;
    const { derivedFieldMapping } = collection;
    const { derivedFieldMappings } = this.state;
    const derivedFieldMappingOptions = derivedFieldMapping.map((derivedField) => ({
      value: derivedField.uuid,
      label: derivedField.mappingName,
    }));
    return (
      <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12">
        <CustomInputWithIcon icon="select" title="Derived Field Mapping" required={true}>
          <CustomSelect
            name="derivedFieldMapping"
            isMulti={false}
            value={derivedFieldMappings}
            options={derivedFieldMappingOptions}
            onChange={setFieldValue}
            onBlur={setFieldTouched}
            onChangeValue={this.handleChange}
            placeholder="Select Derived Field Mapping"
          />
          <ErrorMessage name="derivedFieldMapping">
            {(msg) => <p className="text-error">{msg}</p>}
          </ErrorMessage>
        </CustomInputWithIcon>
      </div>
    );
  };

  render() {
    const { rls, collections, isReadOnly } = this.props;
    const { enableRlsChecked, addDerivedFieldMappingChecked } = this.state;
    const { plugins } = collections;
    const btnDisabled = this.setBtnDisabled();
    const multiTenantPlugin = plugins.find(
      (plugin) => plugin.code === pluginCode.MULTI_TENANT_SAAS,
    );
    let hasSubTenantConfiguration = false;
    if (multiTenantPlugin) {
      if (multiTenantPlugin.setting && multiTenantPlugin.setting.subTenantCollection) {
        hasSubTenantConfiguration = true;
      }
    }
    return (
      <div className="row p-1">
        <div className="col-12">
          <Formik
            initialValues={rls ? { name: '', isPrivate: true } : FilterSchema}
            validationSchema={rls ? RowLevelSecurityFilterSchemaValidation : FilterSchemaValidation}
            onSubmit={(values, { setSubmitting, resetForm }) => {
              isReadOnly ? null : this.handleSubmit(values);
              setSubmitting(false);
              this.clearForm();
              resetForm();
            }}
          >
            {({ setFieldValue, setFieldTouched, values }) => {
              return (
                <Form className="form-horizontal">
                  <div className="row mx-auto">
                    <div className="col-12">{this.showQuery()}</div>
                  </div>
                  <div className="row mx-auto">
                    <div
                      className={
                        rls
                          ? 'col-md-12 col-lg-12 col-sm-12 col-xs-12'
                          : 'col-md-6 col-lg-6 col-sm-12 col-xs-12'
                      }
                    >
                      <CustomInputWithIcon icon="text" title="Filter Name" required={true}>
                        <Field
                          type="text"
                          name="name"
                          className="form-control form-control-sm"
                          placeholder="Filter Name"
                        />
                        <ErrorMessage name="name">
                          {(msg) => <p className="text-error">{msg}</p>}
                        </ErrorMessage>
                      </CustomInputWithIcon>
                    </div>
                    {!rls && (
                      <>
                        <div className="col-md-6 col-lg-6 col-sm-6 col-xs-6">
                          <div className="form-group text-center">
                            <div className="d-flex align-items-center ml-2">
                              <span className="input-group-text p-1 mt-1" title="Is Private">
                                <i className="wb webconnect-toggles"></i>
                              </span>
                              <div className="form-check ml-2 mb-0">
                                <CustomRadio label="Is Private">
                                  <Field
                                    type="checkbox"
                                    name="isPrivate"
                                    className="form-check-input"
                                  />
                                </CustomRadio>
                              </div>
                              <small className="ml-2 mb-0 mt-2">
                                ( Checked - Makes the filter only available for the logged in users
                                to use. )
                              </small>
                            </div>
                            <ErrorMessage name="isPrivate">
                              {(msg) => <p className="text-danger mb-0">{msg}</p>}
                            </ErrorMessage>
                          </div>
                        </div>
                        <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12">
                          {this.createSortFieldSelector(setFieldValue, setFieldTouched)}
                        </div>
                        <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12">
                          <CustomInputWithIcon icon="select" title="Order" required={true}>
                            <CustomSelect
                              name="selectOrderBy"
                              isMulti={false}
                              value={this.state.selectOrderBy}
                              options={this.state.orderByOptions}
                              onChange={setFieldValue}
                              onBlur={setFieldTouched}
                              onChangeValue={this.handleChange}
                              placeholder="Order"
                            />
                            <ErrorMessage name="selectOrderBy">
                              {(msg) => <p className="text-error">{msg}</p>}
                            </ErrorMessage>
                            <TooltipInfo
                              title={collectionFilterSortOrder}
                              headerText={`Select Order By`}
                              showHeader={true}
                              showArrow={true}
                            />
                          </CustomInputWithIcon>
                        </div>
                        <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12">
                          <CustomInputWithIcon icon="select" title="Filter" required={true}>
                            <CustomSelect
                              name="primaryQuery"
                              isMulti={false}
                              value={this.state.primaryQuery}
                              options={primaryQueries}
                              onChange={setFieldValue}
                              onBlur={setFieldTouched}
                              onChangeValue={this.handleChange}
                              placeholder="Selector"
                            />
                            <ErrorMessage name="primaryQuery">
                              {(msg) => <p className="text-error">{msg}</p>}
                            </ErrorMessage>
                            <TooltipInfo
                              title={collectionFilterSelectorText}
                              headerText={`Select Query`}
                              showHeader={true}
                              showArrow={true}
                            />
                          </CustomInputWithIcon>
                        </div>
                        {this.createQuerySelector(setFieldValue, setFieldTouched)}
                        {multiTenantPlugin && (
                          <div className="row w-100" style={{ paddingLeft: '25px' }}>
                            <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12">
                              <div className="d-flex align-items-center">
                                <span
                                  className="input-group-text p-1 mt-1"
                                  title="Filter According to Tenant ID"
                                >
                                  <i className="wb webconnect-toggles"></i>
                                </span>
                                <div className="form-check ml-2 mb-0">
                                  <CustomRadio label="Filter According to Tenant ID">
                                    <Field
                                      type="checkbox"
                                      name="addTenantQuery"
                                      className="form-check-input"
                                      onChange={(event) => {
                                        setFieldValue('addTenantQuery', event.target.checked);
                                      }}
                                    />
                                  </CustomRadio>
                                </div>
                                <small className="ml-2 mb-0 mt-2">
                                  ( Add Current LoggedIn Tenant ID query to filter. )
                                </small>
                              </div>
                              <ErrorMessage name="addTenantQuery">
                                {(msg) => <p className="text-danger mb-0">{msg}</p>}
                              </ErrorMessage>
                            </div>
                            <div
                              className="col-md-6 col-lg-6 col-sm-12 col-xs-12"
                              style={{ paddingLeft: '25px' }}
                            >
                              <div className="d-flex align-items-center justify-content-between">
                                <div className="d-flex align-items-center">
                                  <span
                                    className="input-group-text p-1 mt-1"
                                    title="Filter According to Sub Tenant IDs"
                                  >
                                    <i className="wb webconnect-toggles"></i>
                                  </span>
                                  <div className="form-check ml-2 mb-0">
                                    <CustomRadio
                                      label="Filter According to Sub Tenant IDs"
                                      extraClass={
                                        !hasSubTenantConfiguration || !values.addTenantQuery
                                          ? 'text-muted'
                                          : ''
                                      }
                                    >
                                      <Field
                                        type="checkbox"
                                        name="addSubTenantQuery"
                                        className="form-check-input"
                                        onChange={(event) => {
                                          setFieldValue('addSubTenantQuery', event.target.checked);
                                        }}
                                        disabled={
                                          !hasSubTenantConfiguration || !values.addTenantQuery
                                        }
                                      />
                                    </CustomRadio>
                                  </div>
                                  <small className="ml-2 mb-0 mt-2">
                                    ( Add Current LoggedIn Sub Tenant Ids query to filter. )&nbsp;
                                  </small>
                                  {(!hasSubTenantConfiguration || !values.addTenantQuery) && (
                                    <TooltipInfo
                                      title={
                                        !hasSubTenantConfiguration
                                          ? 'Please configure this in Multi Tenant SAAS Plugin to use.'
                                          : 'Enable Tenant Query to apply Sub Tenant Query'
                                      }
                                      showArrow={true}
                                      iconColor="grey"
                                    />
                                  )}
                                </div>
                              </div>
                              <ErrorMessage name="addSubTenantQuery">
                                {(msg) => <p className="text-danger mb-0">{msg}</p>}
                              </ErrorMessage>
                            </div>
                          </div>
                        )}
                        <div className="col-md-12" style={{ paddingLeft: '25px' }}>
                          <div className="form-group">
                            <div className="d-flex align-items-center justify-content-between">
                              <div className="d-flex align-items-center">
                                <span
                                  className="input-group-text p-1 mt-1"
                                  title="Enable Row Level Security Filter"
                                >
                                  <i className="wb webconnect-toggles"></i>
                                </span>
                                <div className="form-check ml-2 mb-0">
                                  <CustomRadio label="Enable Row Level Security Filter">
                                    <Field
                                      type="checkbox"
                                      name="enableRls"
                                      className="form-check-input"
                                      onChange={(event) => {
                                        this.handleEnableRlsChange(event);
                                        setFieldValue('enableRls', event.target.checked);
                                      }}
                                    />
                                  </CustomRadio>
                                </div>
                                <small className="ml-2 mb-0 mt-2">
                                  ( Enables row level security filter with this filter. )
                                </small>
                              </div>
                              {enableRlsChecked &&
                                this.selectRlsFilter(setFieldValue, setFieldTouched)}
                            </div>
                            <ErrorMessage name="enableRls">
                              {(msg) => <p className="text-danger mb-0">{msg}</p>}
                            </ErrorMessage>
                          </div>
                        </div>
                        <div
                          className="col-md-12"
                          style={{ paddingLeft: '25px', marginTop: '-17px' }}
                        >
                          <div className="form-group">
                            <div className="d-flex align-items-center justify-content-between">
                              <div className="d-flex align-items-center">
                                <span
                                  className="input-group-text p-1 mt-1"
                                  title="Add Derived Field Mapping"
                                >
                                  <i className="wb webconnect-toggles"></i>
                                </span>
                                <div className="form-check ml-2 mb-0">
                                  <CustomRadio label="Add Derived Field Mapping">
                                    <Field
                                      type="checkbox"
                                      name="addDerivedFieldMapping"
                                      className="form-check-input"
                                      onChange={(event) => {
                                        this.handleAddDerivedFieldMappingChange(event);
                                        setFieldValue(
                                          'addDerivedFieldMapping',
                                          event.target.checked,
                                        );
                                      }}
                                    />
                                  </CustomRadio>
                                </div>
                                <small className="ml-2 mb-0 mt-2">
                                  ( Process Derived Fields on the backend. )
                                </small>
                              </div>
                              {addDerivedFieldMappingChecked &&
                                this.selectDerivedFieldMapping(setFieldValue, setFieldTouched)}
                            </div>
                            <ErrorMessage name="addDerivedFieldMapping">
                              {(msg) => <p className="text-danger mb-0">{msg}</p>}
                            </ErrorMessage>
                          </div>
                        </div>
                      </>
                    )}
                    {this.createConditionField(setFieldValue, setFieldTouched)}
                    <div className="col-md-12 col-lg-12 text-right">
                      <button
                        type="button"
                        className="btn btn-theme-green btn-sm"
                        onClick={() => {
                          this.addQueryInCondition();
                          Mixpanel.track('Clicked on- Add Condition in filter');
                        }}
                        title={isReadOnly ? 'Read-Only Mode' : 'Add Condition'}
                        disabled={isReadOnly}
                      >
                        <i className="wb webconnect-plus" />
                        &nbsp;Add Condition
                      </button>
                    </div>
                  </div>
                  <div className="col-md-12 col-lg-12 mt-4 text-right">
                    <button
                      type="submit"
                      className="btn btn-md btn-theme-submit"
                      disabled={btnDisabled || isReadOnly}
                      title={isReadOnly ? 'Read-Only Mode' : 'Create Filter'}
                    >
                      <i className={`wb ${drapcodeIcon('create')}`}></i>&nbsp;Create Filter
                    </button>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
      </div>
    );
  }
}
